<div class="content-wrap">
  <app-header-navigation></app-header-navigation>
  <div class="content-container" [class.full-container]="useCustomTemplate()">
    <div class="ui-expander">
      <router-outlet></router-outlet>
      <app-footer></app-footer>
    </div>
  </div>
</div>

<app-country-restriction *ngIf="countryRestrictionService.showCountryRestrictionBlock"></app-country-restriction>
<app-country-registration-restriction *ngIf="countryRegistrationRestrictionService.showCountryRestrictionBlock"></app-country-registration-restriction>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/template.template.html